import { $http } from '@/utils';

/**
 * @namespace Service
 * @class User
 * @exports Service/Account/UserLongLifeAccessToken
 * @description API User Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class UserLongLifeAccessToken {
	/**
	 * @static @name list
	 * @description Get all users long life access tokens
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post(`account/user/long-life-access-token/list`, payload);
	}

	/**
	 * @static @name post
	 * @description Add a new token
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`account/user/long-life-access-token`, payload);
	}

	/**
	 * @static @name delete
	 * @description Soft delete token
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static delete(id) {
		return $http.delete(`account/user/long-life-access-token/${id}`);
	}
}
